/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: index.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  06.02.23 12:02 pm.
 * Last modified: 06.02.23 12:02 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React, { useState } from 'react';
import { addBuildHash } from '../api/helpers';
import Overlay from '../components/Overlay';
import { useSettings } from '../contexts/SettingsContext';
import { useTranslator } from '../contexts/TranslatorContext';
import HelpIcon from './components/HelpIcon';
import HelpTab from './components/HelpTab';
import LanguagesIcon from './components/LanguagesIcon';
import LanguagesTab from './components/LanguagesTab';
import OptionsIcon from './components/OptionsIcon';
import SettingsTab from './components/SettingsTab';

enum AvailableTabs {
    LANGUAGE = 'language',
    SETTIGS = 'settings',
    HELP = 'help',
}

const SettingsModal = () => {
    const [settings, setSettings] = useSettings();
    const translate = useTranslator();
    const [selectedTab, setSeletedTab] = useState<AvailableTabs>(AvailableTabs.LANGUAGE);

    return (
        <>
            {settings.mode === 'desktop' && settings.openType !== 'ingame' && <Overlay />}
            <div
                className={`egt_lobby_settings_modal_container egt_lobby_settings_modal_container_${settings.mode}`}
                data-open-type={settings.openType}
            >
                <div className="egt_lobby_settings_header">
                    <img
                        src={addBuildHash(`${settings.host}/assets/portal/ui/settings_close.svg`)}
                        alt=""
                        onClick={() =>
                            setSettings?.({
                                ...settings,
                                isSettingsModalOpen: false,
                            })
                        }
                    />
                    {selectedTab === AvailableTabs.LANGUAGE && translate('settings_language')}
                    {selectedTab === AvailableTabs.SETTIGS && translate('settings_options')}
                    {selectedTab === AvailableTabs.HELP && translate('settings_help')}
                </div>
                <div className="egt_lobby_settings_content">
                    {selectedTab === AvailableTabs.LANGUAGE && <LanguagesTab />}
                    {selectedTab === AvailableTabs.SETTIGS && <SettingsTab />}
                    {selectedTab === AvailableTabs.HELP && <HelpTab />}
                </div>
                <div className="egt_lobby_settings_footer">
                    <LanguagesIcon
                        selected={selectedTab === AvailableTabs.LANGUAGE}
                        onClick={() => setSeletedTab(AvailableTabs.LANGUAGE)}
                    />
                    <OptionsIcon
                        selected={selectedTab === AvailableTabs.SETTIGS}
                        onClick={() => setSeletedTab(AvailableTabs.SETTIGS)}
                    />
                    <HelpIcon
                        selected={selectedTab === AvailableTabs.HELP}
                        onClick={() => setSeletedTab(AvailableTabs.HELP)}
                    />
                </div>
            </div>
        </>
    );
};

export default SettingsModal;
